import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import { makeStyles } from "@material-ui/core/styles";
import EditIcon from "@material-ui/icons/Edit";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import BiztranControls from "../../biztran_controls/BiztranControls";
import { Typography, Paper, Tooltip } from "@material-ui/core";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import AddProduct from "./AddProduct";
import EditProduct from "./EditProduct";

const OpportunityDtls = ({ OpportunityID, OpportunityMainData, OpportunityDtlsData, PopulateData, setProductCount }) => {
  const classes = useStyles();

  const [isOpen, setOpen] = useState(false);
  const [isEditOpen, setEditOpen] = useState(false);
  const [OPID, SetOPID] = useState("");
  const [EditOPID, setEditOPTID] = useState("");
  const [OpportunitydtldID, setOpportunitydtldID] = useState("");

  const [rows, setRows] = useState([]);
  const [columns, setColumns] = useState([]);

  const [TotalAmount, setTotalAmount] = useState("");
  const [GSTAmount, setGSTAmount] = useState("");
  const [Description, setDescription] = useState("");

  const [CreatedBy, setCreatedBy] = useState("");
  const [CreatedOn, setCreatedOn] = useState("");
  const [ModifiedBy, setModifiedBy] = useState("");
  const [ModifiedOn, setModifiedOn] = useState("");

  const handleOpenModal = (row) => {
    setEditOpen(true);
    SetOPID(OpportunityID);
    setEditOPTID(EditOPID);
    setOpportunitydtldID(row.id);
  };


  const OpenModal = () => {
    setOpen(true);
    SetOPID(OpportunityID);
    setOpportunitydtldID("");
  };


  useEffect(() => {
    if (OpportunityMainData !== undefined && OpportunityMainData.length > 0) {
      setTotalAmount(OpportunityMainData[0].TotalAmount);
      setGSTAmount(OpportunityMainData[0].GstAmount);
      setDescription(OpportunityMainData[0].Description);
      setCreatedBy(OpportunityMainData[0].CreatedBy);
      setCreatedOn(OpportunityMainData[0].CreatedOn);
      setModifiedBy(OpportunityMainData[0].ModifiedBy);
      setModifiedOn(OpportunityMainData[0].ModifiedOn);
    }
  }, [OpportunityMainData]);



  useEffect(() => {
    const gridCols = [
      {
        field: "id",
        headerName: ".",
        renderCell: (params) => (
          <strong>
            {" "}
            <a
              href="javascript:;"
              onClick={() => {
                handleOpenModal(params);
              }}
            >
              <EditIcon fontSize={"small"}></EditIcon>
            </a>{" "}
          </strong>
        ),
        // renderCell: (params) => (<strong> <a href="javascript:;"  >Select</a> </strong> ),
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 70,
      },
      {
        field: "Seq",
        headerName: ".",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 34,
      },
      {
        field: "ModelCode",
        headerName: "Model Code",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 163,
      },
      {
        field: "ProductName",
        headerName: "Product Name",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 200,
        renderCell: (params) => (
          <Tooltip title={params.row.ProductName} >
            <span className="table-cell-trucate">{params.row.ProductName}</span>
          </Tooltip>
        )
      },
      {
        field: "Quantity",
        headerName: "Qty",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 110,
      },
      {
        field: "Rate",
        headerName: "RateUSD",
        type: 'number',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 150,
      },
      {
        field: "RateINR",
        headerName: "RateINR",
        type: 'number',
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        width: 140,
      },
      // {
      //     field: "CgstPer",
      //     headerName: "Gst %",
      //     type: 'number',
      //     headerClassName: "super-app-theme--header",
      //     headerAlign: "center",
      //     width: 120,
      //  },
      // {
      //   field: "CgstAmt",
      //   headerName: "GST(Amt)",
      //   type: 'number',
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   width: 150,
      // },
      // {
      //   field: "Amount",
      //   headerName: "Amount",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   type: 'number',
      //   width: 160,
      // },
      // {
      //   field: "DiscountPer",
      //   headerName: "Dis %",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   type: 'number',
      //   width: 120,
      // },
      // {
      //   field: "DiscountAmt",
      //   headerName: "DiscRate",
      //   headerClassName: "super-app-theme--header",
      //   headerAlign: "center",
      //   type: 'number',
      //   width: 145,
      // },
      {
        field: "TotalAmount",
        headerName: "Total Amount",
        headerClassName: "super-app-theme--header",
        headerAlign: "center",
        type: 'number',
        width: 180,
      },
    ];
    setColumns(gridCols);
    if (OpportunityDtlsData != null && OpportunityDtlsData.length > 0) {
      setRows(OpportunityDtlsData);
    }
  }, [OpportunityDtlsData]);

  return (
    <Paper style={{ paddingLeft: 10, paddingRight: 10 }}>
      <h2
        style={{
          textDecoration: "underline",
          textDecorationColor: "#0096FF",
          textDecorationThickness: 5,
        }}
      >
        DETAILS
      </h2>
      <Typography className={classes.headerCmn} noWrap>
        Product Details
        <div style={{ width: "100%" }}>
          <div style={{ float: "right" }}>
            <BiztranControls.Button
              text="Add New"
              style={{ margin: "0.2rem", height: "1.6rem" }}
              startIcon={<AddCircleOutlineIcon />}
              onClick={() => {
                OpenModal();
              }}
            />
          </div>
        </div>
      </Typography>
      <Grid spacing={1} container style={{ marginTop: 7, paddingRight: 10 }}>
        <BiztranControls.DataGrid
          rowHeight={25}
          rows={rows}
          columns={columns}
          checkboxSelection={false}
          hideFooterPagination={true}
          Height="430px"
          Width="100%"
        />
        <ModalFrame
          title="Add Product"
          maxWidth="lg"
          isOpen={isOpen}
          setOpen={setOpen}
        >
          <AddProduct
            OpportunityID={OPID}
            OpportunitydtldID={OpportunitydtldID}
            setOpen={setOpen}
            getByIDData={PopulateData}
          />
        </ModalFrame>
        <ModalFrame
          title="Edit Product"
          maxWidth="md"
          isOpen={isEditOpen}
          setOpen={setEditOpen}
        >
          <EditProduct
            OpportunityID={OPID}
            OpportunitydtldID={OpportunitydtldID}
            setOpen={setEditOpen}
            getByIDData={PopulateData}
          />
        </ModalFrame>
        <Grid item xs={6} container direction="row">
          <h5 style={{ width: 120 }}>Total Amount:</h5>
          <h5>{TotalAmount}</h5>
        </Grid>
        {/* <Grid item xs={6} container direction="row">
          <h5 style={{ width: 120 }}>GST Amount:</h5>
          <h5>{GSTAmount}</h5>
        </Grid> */}
        {/* <Grid item xs={6} container direction="row">
          <h5 style={{ width: 120 }}>Description:</h5>
          <h5>{Description}</h5>
        </Grid> */}
        <Grid item xs={12} className={classes.headerCmn}>
          System Information
        </Grid>
        <Grid item xs={6} container direction="row">
          <h5 style={{ width: 120 }}>Created By:</h5>
          <h5>{CreatedBy}</h5>
        </Grid>
        <Grid item xs={6} container direction="row">
          <h5 style={{ width: 120 }}>Last Modified By:</h5>
          <h5>{ModifiedBy}</h5>
        </Grid>
        <Grid item xs={6} container direction="row">
          <h5 style={{ width: 120 }}>Created On:</h5>
          <h5>{CreatedOn}</h5>
        </Grid>
        <Grid item xs={6} container direction="row">
          <h5 style={{ width: 120 }}>Modified On:</h5>
          <h5>{ModifiedOn}</h5>
        </Grid>
      </Grid>
    </Paper>
  );
};


const useStyles = makeStyles((theme) => ({
  header: {
    width: "100%",
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "1.7rem",
    fontSize: "1.8rem",
    display: "flex",
    flexDirection: "row",
  },
  headertext:
  {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2.7rem",
    fontSize: "1.8rem",
    display: "flex",
    flexDirection: "row",
  },
  headerCmn: {
    background: "#e6d8d8", //theme.palette.tertiary.gradient,
    color: "#3d3d3d",
    height: "2rem",
    fontSize: "1rem",
    display: "flex",
    flexDirection: "row",
    margin: "0.3rem",
    fontWeight: "bold",
  },
}));

export default OpportunityDtls;
